import { Component, ViewChild, Inject, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core'
import { Subject, EMPTY, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { MatDialogRef } from "@angular/material";
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SnackbarService } from "../../services/snackbar.service";
import { PaymentDetailsPopupService } from "./patient-payment-details-popup.service"
import { RestrictOutsideScrollService } from "../../services/restrict-outside-scroll.service"
import { SessionStorageService } from '../../services/session-storage.service';

import { config } from "../../../../../config/index";

@Component({
    selector: 'patient-payment-details-popup',
    template: require('./patient-payment-details-popup.component.html'),
    styles: [require('./patient-payment-details-popup.component.less')],
    providers: [PaymentDetailsPopupService, SessionStorageService, SnackbarService],

})

export class PaymentDetailsPopupComponent implements OnInit, OnDestroy {
    parseFloat = parseFloat;

    @Output() newItemEvent = new EventEmitter<string>();
    @Output() loaded = new EventEmitter<string>();

    private _userRole: string;
    private _role = config.role;

    payments: any = [];
    currency: any;
    paymentsId = this.data.id;
    showStopPaymentConfirmationDiv: boolean = false;

    isOneTimeDone: boolean;
    oneTimePaymentId: any;
    amountRegex = /^[0-9]\d{0,9}(\.\d{1,2})?%?$/;
    retryItems: any;
    loadingPopup: boolean = false;
    paymentPopupShow: boolean = false;

    monthsRemaining: any = 5;
    monthlyPayment: any = 10;
    remainingBal: any = 0;

    reducedAmount: any = 0;
    reducedMonths: any = 0;
    lastMonthPayment: any = 0;
    monthRemainingText = 'REDUCES_TO';

    payment_mode: any = '';
    pay_off: any = '';
    pay_off_amount_float: any;
    pay_off_amount: any;
    minPayable: any;
    maxPayable: any;

    payOffErrorClass: string;
    paymentErrorClass: string;
    isAmountError: boolean;

    apiSubscriptions: Subscription[] = [];
    additionalInputSub$: Subject<string> = new Subject<string>();
    inputSubscription: Subscription;
    oneTimeApiSubscription: Subscription;
    downloadApiSubscription: Subscription;

    hasNoUpdate: string = 'no_updates';

    currentDateInTimeZone: any;
    minDate: any;
    maxDate: any;
    receivedDate: any;
    receivedDatePicker: any;
    dateError: boolean;
    sendOfflineEmail: boolean = true;
    clickedPaymentData: any;
    hideDatepicker: boolean;
    pastPaymentsCount: any = 0;

    resendType: string;
    isPaymentUpdated: boolean;

    @ViewChild("oneTimePaymentDialog", { static: false }) oneTimePaymentDialog: any;
    @ViewChild('offlinePaymentConfirmation', { static: false }) offlinePaymentConfirmation: any;
    @ViewChild('resendConfirmation', { static: false }) resendConfirmation: any;
    @ViewChild("datePicker", { static: false }) dateFieldRef: any;

    constructor(
        public _paymentDetailsPopupService: PaymentDetailsPopupService,
        public _mdlSnackbarService: SnackbarService,
        private _restrictOutsideScrollService: RestrictOutsideScrollService,
        private _sessionStorageService: SessionStorageService,
        public paymentDetailsPopup: MatDialogRef<any>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) { }

    ngOnInit() {
        this.getPaymentDetails(this.paymentsId);
        this.userRoleFetch();
    }

    setPayOffAmountAsString() {
        this.pay_off_amount = this.pay_off_amount_float.toString();
    }

    /** Fetching user role **/
    userRoleFetch = () => {
        this._sessionStorageService.readItem(this._role).then((data: any) => {
            this._userRole = data.role;
        });
    }

    getPaymentDetails(id: any) {
        this.retryItems = [];
        this._paymentDetailsPopupService.getPaymentDetails(id)
            .subscribe((res: any) => {
                this.loaded.emit('true');
                this.payments = res.data;
                this.retryItems = this.payments.payment_details.filter((details: any) => details.status === 'payment_fail');
                this.getDateInTimeZone(this.payments.timeZone);

                // provide received offline only for failed and first upcoming offline or first recurring stopped payments
                this.pastPaymentsCount = 0;
                this.payments.payment_details = this.payments.payment_details.map((details: any) => {
                    details['overDueDisabled'] = false;

                    if (details.status === 'payment_fail' || (details.status === 'not_started'
                        && (details.payment_method === 'offline' || this.payments.is_recurring_payment_stopped)
                        && this.isNotFutureDate(details.year, details.month, this.payments.monthly_payment_date))) {
                        details['canMarkOffline'] = true;

                        if (this.pastPaymentsCount > 0) {
                            details['overDueDisabled'] = true;
                        }
                        this.pastPaymentsCount += 1;
                    } else {
                        details['canMarkOffline'] = false;
                    }
                    return details;
                });

                this.currency = config.currency[this.payments.currency];
                this.showStopPaymentConfirmationDiv = false;
                this.paymentPopupShow = true;

            },
                error => {
                    this.loaded.emit('true');
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                    this.paymentPopupShow = true;
                });
    }

    isNotFutureDate(year: any, month: any, day: any) {
        const monthlyDueDate = new Date(year, +month - 1, day);
        monthlyDueDate.setHours(0, 0, 0, 0);
        const currentDateForComparison = this.currentDateInTimeZone;
        currentDateForComparison.setHours(0, 0, 0, 0);

        return (monthlyDueDate <= currentDateForComparison);
    }

    openReceivedOfflinePaymentConfirmation(data: any, type: string) {
        if (type === 'DOWN') {
            this.clickedPaymentData = {
                id: this.payments.id,
                payment_type: type,
                amount: this.payments.down_payment,
                due_date: this.payments.started_at,
            };
        } else if (type === 'ADDITIONAL') {
            this.clickedPaymentData = {
                id: this.oneTimePaymentId,
                payment_type: type,
                amount: this.pay_off === 'additional' ? this.pay_off_amount : this.remainingBal,
            };
        } else {
            this.clickedPaymentData = {
                id: data.id,
                payment_type: type,
                amount: data.total,
                due_date: data.year + "-" + data.month + "-" + this.payments.monthly_payment_date,
            };
        }
        // set min date as patient signed date and for additional as last due date if available.
        this.minDate = this.payments.signed_at;
        if (type === 'ADDITIONAL' && this.payments.additional_min_payment_date) {
            this.minDate = this.payments.additional_min_payment_date;
        }

        this.hideDatepicker = true;
        this.dateError = false;
        this.setReceivedDate(this.payments.time_zone);
        this.sendOfflineEmail = true;
        this.paymentPopupShow = false;
        setTimeout(() => {
            this.hideDatepicker = false;
        });
        this.validateDate()
        this.offlinePaymentConfirmation.show();
    }

    onOfflinePopupClose() {
        this.offlinePaymentConfirmation.close();

        if (this.clickedPaymentData.payment_type === 'ADDITIONAL') {
            if (document.body.classList.contains('hide-dialog')) {
                document.body.classList.remove('hide-dialog');
            }
        } else {
            this.paymentPopupShow = true;
        }
    }

    setReceivedDate(timeZone: string) {
        this.getDateInTimeZone(timeZone);
        const day = this.currentDateInTimeZone.getDate();
        const year = this.currentDateInTimeZone.getFullYear();
        const month = this.currentDateInTimeZone.getMonth() + 1;

        // set max date for datepicker in yyyy-mm-dd format.
        this.maxDate = year + "-" + this.updateDateKey(month) + "-" + this.updateDateKey(day);

        this.receivedDatePicker = this.currentDateInTimeZone;
        this.receivedDate = this.updateDateKey(month) + "/" + this.updateDateKey(day) + "/" + year;
    }

    getDateInTimeZone(timeZone: string) {
        // Get the current date and time in the target timezone
        this.currentDateInTimeZone = new Date().toLocaleString('en-US', { timeZone: timeZone });
        this.currentDateInTimeZone = this.currentDateInTimeZone.split(', ')[0];
        // convert to date string in required format
        this.currentDateInTimeZone = new Date(this.currentDateInTimeZone);
    }

    updateDateKey(value: any) {
        if (value.toString().length === 1) {
            value = "0" + value;
        }
        return value;
    }

    validateDate() {
        this.dateError = false;
        if (!this.receivedDate || (this.receivedDate && this.receivedDate.toString().length !== 10)) {
            this.dateError = true;
            return;
        }
        const date = this.receivedDate.split("/");
        const month = date[0];
        const day = date[1];
        const year = date[2];
        if (month && year && day) {
            if (!this.isValidDate(year, month - 1, day)) {
                this.dateError = true;
                return;
            }
        }
    }

    // check if entered date is today or greater than signed date
    isValidDate(year: any, month: any, day: any) {
        const formattedDate = new Date(year, month, day);
        formattedDate.setHours(0, 0, 0, 0);
        const minDateForComparison = new Date(this.minDate);
        minDateForComparison.setHours(0, 0, 0, 0);
        const currentDateForComparison = this.currentDateInTimeZone;
        currentDateForComparison.setHours(0, 0, 0, 0);

        if (formattedDate.getFullYear() == year && formattedDate.getMonth() == month && formattedDate.getDate() == day
            && formattedDate <= currentDateForComparison && formattedDate >= minDateForComparison) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * Function to open Date picker.
     */
    openDatePicker() {
        if (document.activeElement instanceof HTMLInputElement) {
            document.activeElement.blur();
        }
        setTimeout(this.dateFieldRef.instance.show, 150);
    }

    /**
     * Function to set values based on datepicker.
     */
    onDatePickerChange($event: any) {
        if (!$event) {
            return;
        }
        this.receivedDate = $event;
        this.validateDate();
        return;
    }

    formatDateToYYYMMDD(receivedDate: any) {
        const date = receivedDate.split("/");
        return date[2] + '-' + date[0] + '-' + date[1];
    }

    markAsReceivedOffline() {
        if (this.dateError) {
            this._mdlSnackbarService.showSnackbar('INVALID_DATE', 'error');
        } else {
            this.loadingPopup = true;

            const reqData = {
                payment_date: this.formatDateToYYYMMDD(this.receivedDate),
                send_confirmation_mail: this.sendOfflineEmail,
            };

            if (this.clickedPaymentData) {
                switch (this.clickedPaymentData.payment_type) {
                    case 'Monthly':
                        this.receivedOffline(this.clickedPaymentData.id, reqData);
                        break;
                    case 'ADDITIONAL':
                        this.onOneTimeConfirm(reqData);
                        break;
                    case 'DOWN':
                        this.receivedOfflineDownPayment(this.clickedPaymentData.id, reqData);
                        break;
                    default:
                        break;
                }
            }
        }
    }

    receivedOfflineDownPayment(id: any, reqData: any) {
        this.loadingPopup = true
        this.apiSubscriptions.push(this._paymentDetailsPopupService.receivedOfflineDownPayment(id, reqData)
            .subscribe((res: any) => {
                this._mdlSnackbarService.showSnackbar('PAYMENT_UPDATED', 'success');
                this.offlinePaymentConfirmation.close();
                this.getPaymentDetails(this.paymentsId);
                this.paymentPopupShow = true;
                this.loadingPopup = false;
                this.isPaymentUpdated = true;
            },
                error => {
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                    this.offlinePaymentConfirmation.close();
                    this.paymentPopupShow = true;
                    this.loadingPopup = false;
                }));
    }

    receivedOffline(id: any, reqData: any) {
        this.loadingPopup = true;
        this.apiSubscriptions.push(this._paymentDetailsPopupService.receivedOffline(id, reqData)
            .subscribe((res: any) => {
                this._mdlSnackbarService.showSnackbar('PAYMENT_UPDATED', 'success');
                this.offlinePaymentConfirmation.close();
                this.getPaymentDetails(this.paymentsId);
                this.paymentPopupShow = true;
                this.loadingPopup = false;
            },
                error => {
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                    this.offlinePaymentConfirmation.close();
                    this.paymentPopupShow = true;
                    this.loadingPopup = false;
                }));
    }

    stopRecurring(id: any) {
        this.loadingPopup = true;
        this.apiSubscriptions.push(this._paymentDetailsPopupService.stopRecurring(id)
            .subscribe((res: any) => {
                this._mdlSnackbarService.showSnackbar('RECURRING_PAYMENT_STOPPED_SUCCESS', 'success');
                this.closePaymentDialog();
                this.loadingPopup = false;
            },
                error => {
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                    this.loadingPopup = false;
                }));
    }

    openOneTimePayment() {
        this.paymentPopupShow = false;
        this.oneTimePaymentId = this.payments.id;

        this.oneTimeApiSubscription?.unsubscribe();
        this.loadingPopup = true;
        this.oneTimeApiSubscription = this._paymentDetailsPopupService.getOneTimeRecalculations(this.oneTimePaymentId)
            .subscribe((res: any) => {
                const data = res.data;
                this.remainingBal = data.payable_balance;
                this.loadingPopup = false;
            },
                error => {
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                    this.loadingPopup = false;
                });

        this.monthsRemaining = this.payments.payment_details.filter((item: any) => item.status === 'not_started').length;
        this.monthlyPayment = this.payments.monthly_payment_amount;

        this.oneTimePaymentDialog.show();

        // add delay for calculations on typing
        this.inputSubscription?.unsubscribe();
        this.inputSubscription = this.additionalInputSub$.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            switchMap(amount => {
                this.isAmountError = !+amount;
                if (amount && +amount) {
                    this.isAmountError = (+amount >= +this.remainingBal || +amount < 0.5 || !amount.match(this.amountRegex));
                    if (!this.isAmountError && this.minPayable && this.maxPayable) {
                        this.isAmountError = (+amount < +this.minPayable || +amount > +this.maxPayable)
                    }
                    if (!this.isAmountError) {
                        this.recalculatePayment();
                    } else {
                        this.resetCalculations();
                    }
                } else {
                    this.resetCalculations();
                }
                return EMPTY;
            })
        ).subscribe();
    }

    recalculatePayment() {
        if (this.payment_mode && this.pay_off_amount && +this.pay_off_amount && !this.isAmountError) {
            this.oneTimeApiSubscription?.unsubscribe();
            let payType = '';
            if (this.pay_off === 'additional') {
                payType = this.payment_mode === 'payment' ? 'rate_cut' : 'month_cut';
            }
            this.loadingPopup = true;
            let roundedAmount = (!this.pay_off_amount.includes(".")) ? this.pay_off_amount + ".00" : this.pay_off_amount;
            this.oneTimeApiSubscription = this._paymentDetailsPopupService.getOneTimeRecalculations(this.payments.id, roundedAmount, payType)
                .subscribe((res: any) => {
                    const data = res.data;

                    this.reducedMonths = data.new_month_count;
                    this.reducedAmount = data.new_monthly_pay;
                    this.lastMonthPayment = data.new_last_pay;
                    this.minPayable = data.min_payable;
                    this.maxPayable = data.max_payable;

                    this.monthRemainingText = (this.reducedMonths < this.monthsRemaining) ? 'REDUCES_TO' : 'REMAINS';
                    this.loadingPopup = false;
                    this.verifyPayOff();
                },
                    error => {
                        this.recalculatePaymentErrorHandler(error);
                    });
        }
    }

    recalculatePaymentErrorHandler(error: any) {
        if (error.message === 'Invalid amount') {
            this.isAmountError = true;
            this._mdlSnackbarService.showSnackbar('INVALID_AMOUNT', 'error');
        } else {
            this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
        }
        this.loadingPopup = false;
    }

    verifyPayOff() {
        if (+this.pay_off_amount >= +this.remainingBal) {
            this.isAmountError = true;
            this._mdlSnackbarService.showSnackbar('AMOUNT_EXCEED', 'error');
        } else if (+this.pay_off_amount < +this.minPayable || +this.pay_off_amount > +this.maxPayable
            || +this.lastMonthPayment < +this.minPayable) {
            this.isAmountError = true;
            this._mdlSnackbarService.showSnackbar('INVALID_AMOUNT', 'error');
        }
    }

    validateOneTime() {
        this.payOffErrorClass = '';
        this.paymentErrorClass = '';
        this.isAmountError = false;

        if (!this.pay_off) {
            this.payOffErrorClass = 'radio-invalid';
            this._mdlSnackbarService.showSnackbar('FILL_REQUIRED_DETAILS', 'error');
            return false;
        }
        if (this.pay_off === 'additional') {
            let additionalError = false;
            if (!+this.pay_off_amount) {
                this.isAmountError = true;
                this._mdlSnackbarService.showSnackbar('FILL_REQUIRED_DETAILS', 'error');
                additionalError = true;
            } else if (+this.pay_off_amount >= +this.remainingBal) {
                this.isAmountError = true;
                this._mdlSnackbarService.showSnackbar('AMOUNT_EXCEED', 'error');
                additionalError = true;
            } else if (+this.pay_off_amount < +this.minPayable || +this.pay_off_amount > +this.maxPayable
                || +this.lastMonthPayment < +this.minPayable) {
                this.isAmountError = true;
                this._mdlSnackbarService.showSnackbar('INVALID_AMOUNT', 'error');
                additionalError = true;
            }
            if (!this.payment_mode) {
                this.paymentErrorClass = 'radio-invalid';
                this._mdlSnackbarService.showSnackbar('FILL_REQUIRED_DETAILS', 'error');
                additionalError = true;
            }

            if (additionalError) {
                return false;
            }
        }

        return true;
    }

    onOneTimeConfirm(popupData: any) {
        this.loadingPopup = true;
        let payType = '',
            oneTimeAmount = '';

        if (this.pay_off === 'additional') {
            oneTimeAmount = (!this.pay_off_amount.includes(".")) ? this.pay_off_amount + ".00" : this.pay_off_amount;
            payType = this.payment_mode === 'payment' ? 'rate_cut' : 'month_cut';
        } else if (this.pay_off === 'remaining') {
            oneTimeAmount = this.remainingBal;
            payType = 'complete';
        }

        const reqData = {
            amount: oneTimeAmount,
            pay_type: payType,
            payment_date: popupData.payment_date,
            send_confirmation_mail: popupData.send_confirmation_mail,
        };

        this.apiSubscriptions.push(this._paymentDetailsPopupService.oneTimeReceivedOffline(this.oneTimePaymentId, reqData)
            .subscribe((res: any) => {
                this.offlinePaymentConfirmation.close();
                this.closeOneTimePayment();
                this.loadingPopup = false;
                if (document.body.classList.contains('hide-dialog')) {
                    document.body.classList.remove('hide-dialog');
                }

                this.isPaymentUpdated = true;
                this.isOneTimeDone = true;
                this.paymentPopupShow = true;
                this.getPaymentDetails(this.paymentsId);
                this._mdlSnackbarService.showSnackbar('ONE_TIME_PAYMENT_MARKED_AS_RECEIVED_OFFLINE', 'success');
                this.hasNoUpdate = '';
            },
                error => {
                    this.offlinePaymentConfirmation.close();
                    this.closeOneTimePayment();
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                    this.loadingPopup = false;
                }));
    }

    retryPayment(details: any) {
        this.loadingPopup = true;
        this.apiSubscriptions.push(this._paymentDetailsPopupService.retryPayment(details.id)
            .subscribe((res: any) => {
                this._mdlSnackbarService.showSnackbar('PAYMENT_SUCCESS', 'success');
                this.getPaymentDetails(this.paymentsId);
                this.loadingPopup = false;
            },
                error => {
                    this._mdlSnackbarService.showSnackbar('PAYMENT_FAILED', 'error');
                    this.loadingPopup = false;
                }));
    }

    onOneTimeSubmit() {
        if (this.validateOneTime()) {
            document.body.classList.add('hide-dialog');
            this.openReceivedOfflinePaymentConfirmation({}, 'ADDITIONAL');
        }
    }

    closeOneTimePayment() {
        this.isAmountError = false;
        this.payOffErrorClass = '';
        this.paymentErrorClass = '';
        this.payment_mode = '';
        this.pay_off_amount = '';
        this.pay_off_amount_float = null;
        this.pay_off = '';
        this.remainingBal = '';
        this.minPayable = '';
        this.maxPayable = '';
        this.paymentPopupShow = true;
        this.oneTimePaymentDialog.close();
        if (document.body.classList.contains('hide-dialog')) {
            document.body.classList.remove('hide-dialog');
        }
        setTimeout(() => {
            this._restrictOutsideScrollService.hideBackgroundScroll();
        });
    }

    onModeChange() {
        this.minPayable = '';
        this.maxPayable = '';
        this.recalculatePayment();
    }

    resetCalculations() {
        this.reducedAmount = 0;
        this.reducedMonths = 0;
        this.lastMonthPayment = 0;
    }

    onPayOffChange() {
        this.payOffErrorClass = '';
        this.pay_off_amount = '';
        this.pay_off_amount_float = null;
        this.payment_mode = '';
        this.isAmountError = false;
        this.resetCalculations();
    }

    onAmountKeypress(event: any) {
        if (event.charCode === 101 || event.charCode === 45 || event.charCode === 43 || event.charCode === 69) {
            event.preventDefault();
            return false;
        }
    }

    closePaymentDialog(value?: string) {
        this.isOneTimeDone = false;
        this.oneTimePaymentId = '';
        this.paymentDetailsPopup.close({ isPaymentUpdated: this.isPaymentUpdated });
        this.newItemEvent.emit(value);
    }

    downloadReceipt(statement: any) {
        this.loadingPopup = true;

        this.downloadApiSubscription?.unsubscribe();
        this.downloadApiSubscription = this._paymentDetailsPopupService.receiptDownload(statement.id)
            .subscribe((res: any) => this.getDownloadSuccessHandler(res, statement.filename),
                error => {
                    this.loadingPopup = false;
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                });
    }

    getDownloadSuccessHandler = (response: any, fileName: any) => {
        this.loadingPopup = false;
        if (typeof window.navigator.msSaveBlob === 'function') {
            window.navigator.msSaveBlob(response, fileName);
        } else {
            let blob = response;
            let link = document.createElement('a');
            let binaryData: any = [];
            binaryData.push(blob);
            link.href = window.URL.createObjectURL(new Blob(binaryData, { type: "application/pdf" }))
            link.download = fileName;
            // append the link to the document body
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        }
        this._mdlSnackbarService.showSnackbar('RECEIPT_DOWNLOAD_SUCCESS', 'success');
    }

    openResendConfirmation(type: string) {
        this.resendType = type;
        document.body.classList.add('hide-dialog');
        this.paymentPopupShow = false;
        this.resendConfirmation.show();
    }

    closeResendConfirmation() {
        document.body.classList.remove('hide-dialog');
        this.paymentPopupShow = true;
        this.resendConfirmation.close();
    }

    onSendEmail() {
        this.closeResendConfirmation();
        if (this.resendType === 'PORTAL') {
            this.resendPortal();
        } else if (this.resendType === 'DOWN') {
            this.sendPaymentReminder();
        }
    }

    sendPaymentReminder() {
        this.loadingPopup = true;
        this.apiSubscriptions.push(this._paymentDetailsPopupService.sendPaymentReminder(this.payments.id)
        .subscribe((res: any) => {
                this._mdlSnackbarService.showSnackbar('PAYMENT_NOTIFICATION_MAIL_SUCCESS', 'success');
                this.loadingPopup = false;
            },
                error => {
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                    this.loadingPopup = false;
                }));
    }

    resendPortal() {
        this.loadingPopup = true
        this.apiSubscriptions.push(this._paymentDetailsPopupService.resendPortal(this.payments.id)
            .subscribe((res: any) => {
                this._mdlSnackbarService.showSnackbar('SUCCESS_RESEND_PORTAL', 'success');
                this.loadingPopup = false;
            },
                error => {
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                    this.loadingPopup = false;
                }));
    }

    copyPortal() {
        this.loadingPopup = true
        this.apiSubscriptions.push(this._paymentDetailsPopupService.getPortalLink(this.payments.id)
            .subscribe((res: any) => {
                this.copyToClipboard(res.data.short_url);
                this.loadingPopup = false;
            },
                error => {
                    this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
                    this.loadingPopup = false;
                }));
    }

    copyToClipboard(link: string) {
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(link).then(() => {
                this._mdlSnackbarService.showSnackbar('PORTAL_LINK_COPIED', 'success');
            }).catch(err => {
                this.fallbackCopy(link);
            });
        } else {
            this.fallbackCopy(link);
        }
    }

    // Fallback copy method for iOS/Safari
    fallbackCopy(link: string) {
        const textArea = document.createElement('textarea');
        textArea.value = link;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);

        this._mdlSnackbarService.showSnackbar('PORTAL_LINK_COPIED', 'success');
    }

    ngOnDestroy() {
        this.apiSubscriptions.forEach((subscription: any) => {
            subscription?.unsubscribe();
        });
        this.additionalInputSub$?.unsubscribe();
        this.inputSubscription?.unsubscribe();
        this.oneTimeApiSubscription?.unsubscribe();
        this.downloadApiSubscription?.unsubscribe();
        this.oneTimePaymentDialog?.close();
        this.offlinePaymentConfirmation?.close();
    }
}